import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { LuSearchX } from "react-icons/lu";

const SearchBar = ({ onSearch, onCategorySelect, selectedCategory }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const categories = [
    
  ];

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  const handleCategoryClick = (categoryId) => {
    onCategorySelect(categoryId);
  };

  return (
    <div className="flex items-center justify-between w-full p-4 overflow-x-auto bg-black">
      {/* Categories */}
      <div className="flex w-auto gap-2 text-sm text-white flex-nowrap md:text-lg">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => handleCategoryClick(category.id)}
            className={`px-3 py-1 md:px-4 md:py-2 rounded-lg transition-all duration-300 ${
              selectedCategory === category.id
                ? "bg-gray-500 text-white"
                : "hover:text-gray-400"
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="flex items-center">
        {isSearchOpen && (
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleInputChange}
            className="hidden p-2 text-white placeholder-gray-400 transition-all duration-300 bg-gray-800 border border-gray-600 rounded-lg md:block w-36 md:w-56 focus:outline-none focus:ring-2 focus:ring-gray-500"
          />
        )}
        <button
          onClick={() => setIsSearchOpen(!isSearchOpen)}
          className="ml-2 focus:outline-none"
        >
          {isSearchOpen ? (
            <LuSearchX className="text-white hover:text-gray-400" size={20} />
          ) : (
            <FaSearch className="text-white hover:text-gray-400" size={20} />
          )}
        </button>
      </div>

      {/* Mobile Search */}
      {isSearchOpen && (
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleInputChange}
          className="absolute w-[85%]  h-16 p-2 text-white placeholder-gray-400 transition-all duration-300 bg-gray-800 border border-gray-600 rounded-lg md:hidden  focus:outline-none focus:ring-2 focus:ring-gray-500"
        />
      )}
    </div>
  );
};

export default SearchBar;

// import React, { useState } from "react";
// import { FaSearch } from "react-icons/fa";
// import { LuSearchX } from "react-icons/lu";

// const SearchBar = ({ onSearch, onCategorySelect, selectedCategory }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isSearchOpen, setIsSearchOpen] = useState(false);

//   const categories = [
//     { id: "now_playing", name: "Now Playing" },
//     { id: "popular", name: "Popular" },
//     { id: "top_rated", name: "Top Rated" },
//     { id: "upcoming", name: "Upcoming" },
//     { id: "my_movies", name: "My Movies" },
//   ];

//   const handleInputChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     onSearch(value);
//   };

//   const handleCategoryClick = (categoryId) => {
//     onCategorySelect(categoryId);
//   };

//   return (
//     <div className="flex items-center justify-between w-full p-4 overflow-x-auto bg-black">
//       {/* Categories */}
//       <div className="flex w-auto gap-2 text-sm text-white flex-nowrap md:text-lg">
//         {categories.map((category) => (
//           <button
//             key={category.id}
//             onClick={() => handleCategoryClick(category.id)}
//             className={`px-3 py-1 md:px-4 md:py-2 rounded-lg transition-all duration-300 ${
//               selectedCategory === category.id
//                 ? "bg-gray-500 text-white"
//                 : "hover:text-gray-400"
//             }`}
//           >
//             {category.name}
//           </button>
//         ))}
//       </div>

//       {/* Search */}
//       <div className="flex items-center">
//         {isSearchOpen && (
//           <input
//             type="text"
//             placeholder="Buscar..."
//             value={searchTerm}
//             onChange={handleInputChange}
//             className="hidden p-2 text-white placeholder-gray-400 transition-all duration-300 bg-gray-800 border border-gray-600 rounded-lg md:block w-36 md:w-56 focus:outline-none focus:ring-2 focus:ring-gray-500"
//           />
//         )}
//         <button
//           onClick={() => setIsSearchOpen(!isSearchOpen)}
//           className="ml-2 focus:outline-none"
//         >
//           {isSearchOpen ? (
//             <LuSearchX className="text-white hover:text-gray-400" size={20} />
//           ) : (
//             <FaSearch className="text-white hover:text-gray-400" size={20} />
//           )}
//         </button>
//       </div>
//       {isSearchOpen && (
//         <input
//           type="text"
//           placeholder="Buscar..."
//           value={searchTerm}
//           onChange={handleInputChange}
//           className="absolute w-[85%]  h-16 p-2 text-white placeholder-gray-400 transition-all duration-300 bg-gray-800 border border-gray-600 rounded-lg md:hidden  focus:outline-none focus:ring-2 focus:ring-gray-500"
//         />
//       )}
//     </div>
//   );
// };

// export default SearchBar;

// import React, { useState } from "react";
// import { FaSearch } from "react-icons/fa";
// import { LuSearchX } from "react-icons/lu";

// const SearchBar = ({ onSearch, onCategorySelect }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("now_playing");
//   const [isSearchOpen, setIsSearchOpen] = useState(false);

//   // NOMBRE DE LAS CATEGORÍAS
//   const categories = [
//     { id: "now_playing", name: "Now Playing" },
//     { id: "popular", name: "Popular" },
//     { id: "top_rated", name: "Top Rated" },
//     { id: "upcoming", name: "Upcoming" },
//   ];

//   const handleInputChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     onSearch(value);
//   };

//   const handleCategoryClick = (categoryId) => {
//     setSelectedCategory(categoryId);
//     onCategorySelect(categoryId);
//   };

//   return (
//     <div className="flex items-center justify-between w-full p-4 overflow-x-auto bg-black">
//       {/* Categorías en una sola línea sin saltar abajo */}
//       <div className="flex w-auto gap-2 text-sm text-white flex-nowrap md:text-lg">
//         {categories.map((category) => (
//           <button
//             key={category.id}
//             onClick={() => handleCategoryClick(category.id)}
//             className={`px-3 py-1 md:px-4 md:py-2 rounded-lg transition-all duration-300 ${
//               selectedCategory === category.id
//                 ? "bg-gray-500 text-white"
//                 : "hover:text-gray-400"
//             }`}
//           >
//             {category.name}
//           </button>
//         ))}
//       </div>

//       {/* Buscador siempre en su lugar */}
//       <div className="flex items-center">
//         {isSearchOpen && (
//           <input
//             type="text"
//             placeholder="Buscar..."
//             value={searchTerm}
//             onChange={handleInputChange}
//             className="hidden p-2 text-white placeholder-gray-400 transition-all duration-300 bg-gray-800 border border-gray-600 rounded-lg md:block w-36 md:w-56 focus:outline-none focus:ring-2 focus:ring-gray-500"
//           />
//         )}
//         <button
//           onClick={() => setIsSearchOpen(!isSearchOpen)}
//           className="ml-2 focus:outline-none"
//         >
//           {isSearchOpen ? (
//             <LuSearchX className="text-white hover:text-gray-400" size={20} />
//           ) : (
//             <FaSearch className="text-white hover:text-gray-400" size={20} />
//           )}{" "}
//         </button>
//       </div>
//       {isSearchOpen && (
//         <input
//           type="text"
//           placeholder="Buscar..."
//           value={searchTerm}
//           onChange={handleInputChange}
//           className="absolute w-[85%]  h-16 p-2 text-white placeholder-gray-400 transition-all duration-300 bg-gray-800 border border-gray-600 rounded-lg md:hidden  focus:outline-none focus:ring-2 focus:ring-gray-500"
//         />
//       )}
//     </div>
//   );
// };

// export default SearchBar;
